import client from '@/lib/axios-client'
import type { ApiResponse } from '@/types'
import type {
	QuizInput,
	QuizListOutput,
	QuizOutput,
	QuizParams,
} from '@/types/quiz'

const QUIZ_URL = '/quizzes'

export async function getQuizList(
	params?: QuizParams,
): Promise<ApiResponse<QuizListOutput>> {
	const response = await client.get(QUIZ_URL, { params })
	return response.data.data
}

export async function getQuizListByBranchId(
	id: string,
): Promise<ApiResponse<QuizOutput[]>> {
	const response = await client.get(`${QUIZ_URL}/branch/${id}`)
	return response.data.data
}

export async function createQuiz(data: QuizInput): Promise<QuizOutput> {
	const formData = buildQuizFormData(data)
	const response = await client.post(QUIZ_URL, formData, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	})
	return response.data.data
}

export async function updateQuiz(
	id: string,
	data: QuizInput,
): Promise<QuizOutput> {
	const formData = buildQuizFormData(data)
	const response = await client.put(`${QUIZ_URL}/${id}`, formData, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	})
	return response.data.data
}

export async function deleteQuiz(id: string): Promise<void> {
	await client.delete(`${QUIZ_URL}/${id}`)
}

function buildQuizFormData(data: QuizInput): FormData {
	const formData = new FormData()
	const questionImages: File[] = []
	const questionsPayload = data.questions.map((question) => {
		const questionPayload: {
			id?: string
			question: string
			imageFileIndex?: number
			removeImage?: boolean
		} = {
			question: question.question,
		}

		if (question.id) {
			questionPayload.id = question.id
		}

		if (question.image instanceof File) {
			questionImages.push(question.image)
			questionPayload.imageFileIndex = questionImages.length - 1
		}

		if (question.removeImage) {
			questionPayload.removeImage = true
		}

		return questionPayload
	})

	formData.append('title', data.title)
	if (data.kind) {
		formData.append('kind', data.kind)
	}
	if (data.score !== undefined) {
		formData.append('score', String(data.score))
	}
	if (data.description) {
		formData.append('description', data.description)
	}

	questionImages.forEach((image) => {
		formData.append('questionImages', image, image.name)
	})

	formData.append('questions', JSON.stringify(questionsPayload))

	if (data.branchesId.length > 0) {
		formData.append('branchesId', JSON.stringify(data.branchesId))
	}

	return formData
}
